import { useEffect } from 'react';
import { Box } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { motion, useScroll, useSpring, useTransform } from 'framer-motion';

type ProgressBarProps = {
  fullWidthSeparator?: boolean;
};

const StyledBox = styled(Box)(() => ({
  bottom: 0,
  height: '3px',
  left: 0,
  overflow: 'hidden',
  position: 'fixed',
  width: '100%',
}));

export function ProgressBar({ fullWidthSeparator = false }: ProgressBarProps): React.ReactElement {
  const theme = useTheme();
  const { scrollYProgress } = useScroll();

  const progress = useSpring(scrollYProgress, {
    damping: 30,
    restDelta: 0.001,
    stiffness: 100,
  });

  useEffect(() => {
    if (fullWidthSeparator) {
      progress.set(1);
    } else {
      progress.set(scrollYProgress.get());
    }
  }, [fullWidthSeparator, progress, scrollYProgress]);

  const width = useTransform(progress, [0, 1], ['0%', '100%']);

  return (
    <StyledBox>
      <motion.div
        style={{
          background: theme.palette.websiteBrand.gradients.primaryLinear,
          borderRadius: theme.borderRadius.lg,
          height: '100%',
          width,
        }}
      />
    </StyledBox>
  );
}
